import React, { useState, useEffect } from "react";
import { Grid, Typography, Button, TextField } from "@material-ui/core";
import { Box, Container } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSelector } from "react-redux";
import Navbar from "../components/Navbar";
import WebFooter from "../components/WebFooter";

import contactHero from "../assets/web/contact-us-hero.png";
import storyImage from "../assets/web/abt-us/story-image.png";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import ContactusMobile from "./contactus.-mobile";

function Contactus() {
  const isDesktop = useMediaQuery("(min-width: 900px)");

  useEffect(() => {
    if (isDesktop) {
      window.scrollTo(0, 0);
    }
  }, [isDesktop]);

  const reduxStoreInfo = useSelector((state) => state.sessionReducer?.store_details);
  const storeInfoConfig = useSelector((state) => state.sessionReducer?.store_config);
  const primaryColor =
    storeInfoConfig?.general_config?.primary_color ||
    reduxStoreInfo?.primary_color ||
    "#272727";

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  if (!isDesktop) {
    return <ContactusMobile />;
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.fullName && formData.email) {
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        setFormData({ fullName: "", email: "", subject: "", message: "" });
      }, 4000);
    }
  };

  const storeName = reduxStoreInfo?.store_name || "The Spice Garden";
  const storeAddress =
    [
      reduxStoreInfo?.store_ad1,
      reduxStoreInfo?.store_city,
      reduxStoreInfo?.store_country,
      reduxStoreInfo?.store_zip,
    ]
      .filter(Boolean)
      .join(", ") || "128 Culinary Way, Spice District, NY 10013";

  const storePhone =
    reduxStoreInfo?.store_contact_no ||
    reduxStoreInfo?.store_phone ||
    "+1(555) 767-4273";

  const storeEmail =
    reduxStoreInfo?.email_id ||
    reduxStoreInfo?.store_email ||
    "hello@thespicegarden.com";

  const geoLatitude = reduxStoreInfo?.geo_latitude || reduxStoreInfo?.latitude;
  const geoLongitude = reduxStoreInfo?.geo_longitude || reduxStoreInfo?.longitude;

  const mapLocationQuery = (geoLatitude && geoLongitude)
    ? `${geoLatitude},${geoLongitude}`
    : encodeURIComponent(storeAddress);

  return (
    <Box style={{ backgroundColor: "#ffffff", minHeight: "100vh", fontFamily: "Satoshi, sans-serif" }}>
      {/* Top Navbar */}
      <Navbar />

      {/* Hero Section */}
      <Box
        style={{
          position: "relative",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(${contactHero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "#ffffff",
          padding: isDesktop ? "90px 24px" : "60px 16px",
          textAlign: "center",
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h2"
            style={{
              fontWeight: 700,
              fontSize: isDesktop ? "44px" : "32px",
              fontFamily: "Satoshi, sans-serif",
              color: "#ffffff",
              letterSpacing: "-0.5px",
            }}
          >
            Contact Us
          </Typography>
          <Typography
            style={{
              fontSize: isDesktop ? "16px" : "14px",
              color: "rgba(255, 255, 255, 0.88)",
              fontFamily: "Satoshi, sans-serif",
              maxWidth: "680px",
              margin: "14px auto 0",
              lineHeight: 1.5,
            }}
          >
            Get in touch with our kitchen team, reserve a custom table, or book authentic catering for your next heritage celebration.
          </Typography>
        </Container>
      </Box>

      {/* Ways to Connect Section */}
      <Box
        style={{
          backgroundColor: "#FAF9F6",
          padding: isDesktop ? "70px 24px" : "50px 16px",
          borderBottom: "1px solid #EAEAEA",
        }}
      >
        <Container maxWidth="lg">
          <Box style={{ textAlign: "center", marginBottom: "48px" }}>
            <Typography
              variant="h4"
              style={{
                fontWeight: 700,
                fontSize: isDesktop ? "32px" : "26px",
                color: "#1A1A1A",
                fontFamily: "Satoshi, sans-serif",
              }}
            >
              Ways to Connect
            </Typography>
            <Typography
              style={{
                fontSize: "15px",
                color: "#666666",
                fontFamily: "Satoshi, sans-serif",
                maxWidth: "600px",
                margin: "8px auto 0",
                lineHeight: 1.5,
              }}
            >
              Whether you want to dine with us, inquire about a spice blend, or just say hello, we are here to welcome you.
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {/* Card 1: Our Restaurant */}
            <Grid item xs={12} sm={6} md={3}>
              <Box
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  padding: "28px 22px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.04)",
                  border: "1px solid #EAEAEA",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  textAlign: "left",
                  boxSizing: "border-box",
                }}
              >
                <Box
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "50%",
                    backgroundColor: `${primaryColor}18`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  <LocationOnIcon style={{ color: primaryColor, fontSize: "22px" }} />
                </Box>
                <Typography
                  style={{
                    fontWeight: 700,
                    fontSize: "17px",
                    color: "#1A1A1A",
                    fontFamily: "Satoshi, sans-serif",
                    textAlign: "left",
                  }}
                >
                  Our Restaurant
                </Typography>
                <Typography
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#444444",
                    fontFamily: "Satoshi, sans-serif",
                    marginTop: "6px",
                    lineHeight: 1.4,
                    textAlign: "left",
                  }}
                >
                  {storeAddress}
                </Typography>
                <Typography
                  style={{
                    fontSize: "12.5px",
                    color: "#888888",
                    fontFamily: "Satoshi, sans-serif",
                    marginTop: "12px",
                    lineHeight: 1.4,
                    textAlign: "left",
                  }}
                >
                  Located in the heart of downtown, easily accessible by public transit.
                </Typography>
              </Box>
            </Grid>

            {/* Card 2: Phone & Bookings */}
            <Grid item xs={12} sm={6} md={3}>
              <Box
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  padding: "28px 22px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.04)",
                  border: "1px solid #EAEAEA",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  textAlign: "left",
                  boxSizing: "border-box",
                }}
              >
                <Box
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "50%",
                    backgroundColor: `${primaryColor}18`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  <PhoneIcon style={{ color: primaryColor, fontSize: "22px" }} />
                </Box>
                <Typography
                  style={{
                    fontWeight: 700,
                    fontSize: "17px",
                    color: "#1A1A1A",
                    fontFamily: "Satoshi, sans-serif",
                    textAlign: "left",
                  }}
                >
                  Phone & Bookings
                </Typography>
                <Typography
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#444444",
                    fontFamily: "Satoshi, sans-serif",
                    marginTop: "6px",
                    lineHeight: 1.4,
                    textAlign: "left",
                  }}
                >
                  {storePhone}
                </Typography>
                <Typography
                  style={{
                    fontSize: "12.5px",
                    color: "#888888",
                    fontFamily: "Satoshi, sans-serif",
                    marginTop: "12px",
                    lineHeight: 1.4,
                    textAlign: "left",
                  }}
                >
                  Call us directly for group reservations, table customization, or events.
                </Typography>
              </Box>
            </Grid>

            {/* Card 3: Email Inquiries */}
            <Grid item xs={12} sm={6} md={3}>
              <Box
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  padding: "28px 22px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.04)",
                  border: "1px solid #EAEAEA",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  textAlign: "left",
                  boxSizing: "border-box",
                }}
              >
                <Box
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "50%",
                    backgroundColor: `${primaryColor}18`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  <EmailIcon style={{ color: primaryColor, fontSize: "22px" }} />
                </Box>
                <Typography
                  style={{
                    fontWeight: 700,
                    fontSize: "17px",
                    color: "#1A1A1A",
                    fontFamily: "Satoshi, sans-serif",
                    textAlign: "left",
                  }}
                >
                  Email Inquiries
                </Typography>
                <Typography
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#444444",
                    fontFamily: "Satoshi, sans-serif",
                    marginTop: "6px",
                    lineHeight: 1.4,
                    textAlign: "left",
                  }}
                >
                  {storeEmail}
                </Typography>
                <Typography
                  style={{
                    fontSize: "12.5px",
                    color: "#888888",
                    fontFamily: "Satoshi, sans-serif",
                    marginTop: "12px",
                    lineHeight: 1.4,
                    textAlign: "left",
                  }}
                >
                  Send us your feedback, partner inquiries, or event reservation details.
                </Typography>
              </Box>
            </Grid>

            {/* Card 4: Opening Hours */}
            <Grid item xs={12} sm={6} md={3}>
              <Box
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  padding: "28px 22px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.04)",
                  border: "1px solid #EAEAEA",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  textAlign: "left",
                  boxSizing: "border-box",
                }}
              >
                <Box
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "50%",
                    backgroundColor: `${primaryColor}18`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  <AccessTimeIcon style={{ color: primaryColor, fontSize: "22px" }} />
                </Box>
                <Typography
                  style={{
                    fontWeight: 700,
                    fontSize: "17px",
                    color: "#1A1A1A",
                    fontFamily: "Satoshi, sans-serif",
                    textAlign: "left",
                  }}
                >
                  Opening Hours
                </Typography>
                <Typography
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#444444",
                    fontFamily: "Satoshi, sans-serif",
                    marginTop: "6px",
                    lineHeight: 1.4,
                    textAlign: "left",
                  }}
                >
                  Mon - Fri: 11:00 AM – 10:00 PM
                </Typography>
                <Typography
                  style={{
                    fontSize: "12.5px",
                    color: "#888888",
                    fontFamily: "Satoshi, sans-serif",
                    marginTop: "8px",
                    lineHeight: 1.4,
                    textAlign: "left",
                  }}
                >
                  Sat - Sun: 10:00 AM – 11:00 PM (Brunch & Heritage Dinner specials)
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Send A Message & Map Section */}
      {/* <Box style={{ padding: isDesktop ? "80px 24px" : "50px 16px", backgroundColor: "#ffffff" }}>
        <Container maxWidth="lg">
          <Grid container spacing={5}> */}
            {/* Left Column: Form */}
            {/* <Grid item xs={12} md={6} style={{ textAlign: "left" }}>
              <Typography
                style={{
                  color: primaryColor,
                  fontSize: "14px",
                  fontWeight: 700,
                  fontFamily: "Satoshi, sans-serif",
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  textAlign: "left",
                  display: "block",
                }}
              >
                Send A Message
              </Typography>
              <Typography
                variant="h4"
                style={{
                  fontSize: isDesktop ? "32px" : "26px",
                  fontWeight: 700,
                  color: "#1A1A1A",
                  fontFamily: "Satoshi, sans-serif",
                  marginTop: "6px",
                  marginBottom: "32px",
                  textAlign: "left",
                  display: "block",
                }}
              >
                We'd Love to Hear From You
              </Typography>

              {submitted && (
                <Box
                  style={{
                    backgroundColor: "#E8F5E9",
                    color: "#2E7D32",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    marginBottom: "24px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    fontWeight: 600,
                    textAlign: "left",
                  }}
                >
                  <CheckCircleOutlineIcon style={{ fontSize: "20px" }} />
                  Thank you! Your message has been sent successfully. We'll get back to you shortly.
                </Box>
              )}

              <form onSubmit={handleSubmit} style={{ textAlign: "left" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} style={{ textAlign: "left" }}>
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontSize: "13px",
                        color: "#333333",
                        marginBottom: "6px",
                        fontFamily: "Satoshi, sans-serif",
                        textAlign: "left",
                        display: "block",
                      }}
                    >
                      Full Name
                    </Typography>
                    <input
                      type="text"
                      name="fullName"
                      placeholder="Your name"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: "100%",
                        height: "44px",
                        borderRadius: "8px",
                        border: "1px solid #E0E0E0",
                        padding: "0 14px",
                        fontSize: "14px",
                        fontFamily: "Satoshi, sans-serif",
                        outline: "none",
                        boxSizing: "border-box",
                        transition: "border 0.2s",
                        textAlign: "left",
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} style={{ textAlign: "left" }}>
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontSize: "13px",
                        color: "#333333",
                        marginBottom: "6px",
                        fontFamily: "Satoshi, sans-serif",
                        textAlign: "left",
                        display: "block",
                      }}
                    >
                      Email Address
                    </Typography>
                    <input
                      type="email"
                      name="email"
                      placeholder="Your email address"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: "100%",
                        height: "44px",
                        borderRadius: "8px",
                        border: "1px solid #E0E0E0",
                        padding: "0 14px",
                        fontSize: "14px",
                        fontFamily: "Satoshi, sans-serif",
                        outline: "none",
                        boxSizing: "border-box",
                        textAlign: "left",
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontSize: "13px",
                        color: "#333333",
                        marginBottom: "6px",
                        fontFamily: "Satoshi, sans-serif",
                        marginTop: "4px",
                        textAlign: "left",
                        display: "block",
                      }}
                    >
                      Subject
                    </Typography>
                    <input
                      type="text"
                      name="subject"
                      placeholder="How can we help you?"
                      value={formData.subject}
                      onChange={handleInputChange}
                      style={{
                        width: "100%",
                        height: "44px",
                        borderRadius: "8px",
                        border: "1px solid #E0E0E0",
                        padding: "0 14px",
                        fontSize: "14px",
                        fontFamily: "Satoshi, sans-serif",
                        outline: "none",
                        boxSizing: "border-box",
                        textAlign: "left",
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontSize: "13px",
                        color: "#333333",
                        marginBottom: "6px",
                        fontFamily: "Satoshi, sans-serif",
                        marginTop: "4px",
                        textAlign: "left",
                        display: "block",
                      }}
                    >
                      Your Message
                    </Typography>
                    <textarea
                      name="message"
                      rows={4}
                      placeholder="Share your thoughts, suggestions, or booking inquiries..."
                      value={formData.message}
                      onChange={handleInputChange}
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        border: "1px solid #E0E0E0",
                        padding: "12px 14px",
                        fontSize: "14px",
                        fontFamily: "Satoshi, sans-serif",
                        outline: "none",
                        boxSizing: "border-box",
                        resize: "vertical",
                        textAlign: "left",
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Button
                      type="submit"
                      variant="contained"
                      disableElevation
                      style={{
                        backgroundColor: primaryColor,
                        color: "white",
                        borderRadius: "8px",
                        padding: "12px 32px",
                        fontWeight: 600,
                        fontSize: "15px",
                        textTransform: "none",
                        fontFamily: "Satoshi, sans-serif",
                        marginTop: "12px",
                      }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Grid> */}

            {/* Right Column: Map Card & Takeout Card */}
            {/* <Grid item xs={12} md={6}> */}
              {/* <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                  height: "100%",
                }}
              > */}
                {/* Interactive Google Map pinned to geo_latitude & geo_longitude */}
                {/* <Box
                  style={{
                    backgroundColor: "#F7F5EE",
                    borderRadius: "16px",
                    border: "1px solid #E5E0D5",
                    height: "280px",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }} */}
                {/* > */}
                  {/* <iframe
                    title="Store Location Map"
                    width="100%"
                    height="100%"
                    style={{ border: 0, borderRadius: "16px" }}
                    loading="lazy"
                    allowFullScreen
                    src={`https://maps.google.com/maps?q=${mapLocationQuery}&z=15&output=embed`}
                  /> */}
                  {/* Top Location Badge with link to Google Maps */}
                  {/* <Box
                    component="a"
                    href={`https://www.google.com/maps/search/?api=1&query=${mapLocationQuery}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      position: "absolute",
                      top: "12px",
                      left: "12px",
                      backgroundColor: "#ffffff",
                      borderRadius: "20px",
                      padding: "6px 14px",
                      boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      zIndex: 2,
                      textDecoration: "none",
                    }}
                  >
                    <LocationOnIcon style={{ color: primaryColor, fontSize: "16px" }} />
                    <Typography
                      style={{
                        fontSize: "12.5px",
                        fontWeight: 700,
                        color: "#333333",
                        fontFamily: "Satoshi, sans-serif",
                      }}
                    >
                      {storeName}
                    </Typography>
                  </Box> */}
                {/* </Box> */}

                {/* Bottom Card: Kitchen Pick-up & Catering Takeout */}
                {/* <Box
                  style={{
                    backgroundColor: `${primaryColor}0D`,
                    borderRadius: "16px",
                    border: `1.5px solid ${primaryColor}40`,
                    padding: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                  }}
                > */}
                  {/* <img
                    src={storyImage}
                    alt="Kitchen Catering"
                    style={{
                      width: "90px",
                      height: "85px",
                      borderRadius: "10px",
                      objectFit: "cover",
                      flexShrink: 0,
                    }}
                  /> */}
                  {/* <Box>
                    <Typography
                      style={{
                        fontWeight: 700,
                        fontSize: "15px",
                        color: "#1A1A1A",
                        fontFamily: "Satoshi, sans-serif",
                      }}
                    >
                      Kitchen Pick-up & Catering Takeout
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "12.5px",
                        color: "#666666",
                        fontFamily: "Satoshi, sans-serif",
                        marginTop: "4px",
                        lineHeight: 1.4,
                      }}
                    >
                      Our pickup counter is open during normal hours. Bring authentic slow-cooked Indian spices directly to your private parties.
                    </Typography>
                  </Box> */}
                {/* </Box> */}
              {/* </Box> */}
            {/* </Grid>
          </Grid>
        </Container>
      </Box> */}

      {/* Web Footer */}
      <WebFooter storeInfo={reduxStoreInfo} primaryColor={primaryColor} />
    </Box>
  );
}

export default Contactus;
